import styled from '@xstyled/styled-components';
import React, { ButtonHTMLAttributes, FC } from 'react';
import { t } from 'ttag';
import Icon from '~/assets/icons/rewind-btn-eds.svg';

const Button = styled.button`
  /* CAT-1244 / WCAG 1.4.12: min-* so Stylus text-spacing cannot clip the Rewind HUD. */
  background: #2e2e2e;
  box-sizing: border-box;
  width: 38px;
  height: 38px;
  min-width: 38px;
  min-height: 38px;
  flex-shrink: 0;
  overflow: visible;
  border-radius: md;
  border: none;
  display: block;
  color: #fff;
  position: relative;
  padding: 0;
  margin: 0;
  font-size: 0;
  line-height: 0;
  cursor: pointer;

  &:focus {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }

  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: md;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }

  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
  }
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: block;
  width: 20px;
  height: 20px;

  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 16px;
    height: 16px;
  }
`;

export const RewindButtonEds: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  ...props
}) => (
  <Button aria-label={t`Rewind 10 seconds`} {...props} style={{ zIndex: 100 }}>
    <StyledIcon aria-hidden="true" focusable="false" />
  </Button>
);
